import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrgNavigate } from "app/routes/useOrgNavigate";

import Button from '@mui/material/Button';

import StatePage from '@/operator/pages/states/StatePage';
import { PageStateContext } from '@/operator/components/general/multiStepForm/formStateContext';
import image from '@/operator/public/assets/images/background/dance-1.png';
import { appRoutes } from '@/routes/constants';

function AllDone() {
    const { t } = useTranslation();
    const navigate = useOrgNavigate();

    const pageState = useContext(PageStateContext);

    return (
        <div style={{ paddingTop: '48px', paddingBottom: '48px' }}>
            <StatePage
                headline={t('FormAllDone.Headline', {
                    selectedConnector: pageState.selectedConnector,
                })}
                description={t('FormAllDone.Description')}
                imagePath={image}
                actionElement={
                    <Button
                        color="secondary"
                        size="small"
                        style={{
                            justifyContent: 'center',
                        }}
                        onClick={() =>
                            navigate(appRoutes.OPERATOR_ADMIN_CONNECTIONS)
                        }
                    >
                        {t('FormAllDone.Button')}
                    </Button>
                }
                background="inherit"
                width="100%"
                height="100%"
                imgDimension="200px"
            />
        </div>
    );
}

export default AllDone;
